import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/shadcn/card'
import { Button } from '@/components/shadcn/button'
import { Badge } from '@/components/shadcn/badge'
import { CreditCard, Download, TrendingUp, DollarSign } from 'lucide-react'

export default function BillingPage() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">计费管理</h1>
        <p className="text-muted-foreground">管理你的订阅和账单</p>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">当前套餐</CardTitle>
            <Badge variant="default">Pro</Badge>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">¥99/月</div>
            <p className="text-xs text-muted-foreground">下次续费：2024-02-14</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">本月使用</CardTitle>
            <TrendingUp className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">¥87</div>
            <p className="text-xs text-muted-foreground">按用量计费部分</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">账户余额</CardTitle>
            <DollarSign className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">¥156</div>
            <p className="text-xs text-muted-foreground">可用余额</p>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>功能开发中</CardTitle>
          <CardDescription>
            计费管理功能正在开发中
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            此页面将包含账单历史、付款方式、套餐升级等功能。
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
